import { CountryPhoneInput } from './phone-input'
export * from './phone-input';
export * from './area-select';

export type { CountryPhoneInputValue } from './typings';
export * from './config';
export * from './sources';
export default CountryPhoneInput;
